import { createFileRoute, redirect } from '@tanstack/react-router'
import { AdminDashboard } from '@/pages/AdminDashboard'
import { supabase } from '@/lib/supabase'

export const Route = createFileRoute('/')({
  component: AdminDashboard,
  beforeLoad: async () => {
    // Check user type and redirect to appropriate dashboard
    const { data: { session } } = await supabase.auth.getSession();

    if (session?.user) {
      const userType = session.user.user_metadata?.['user_type'];

      // Redirect assistants to their dashboard
      if (userType === 'assistant') {
        throw redirect({ to: '/assistant-dashboard' });
      }

      // Redirect staff to their appropriate dashboard
      if (session.user.user_metadata?.['role']) {
        const role = session.user.user_metadata['role'];
        if (role === 'server') {
          throw redirect({ to: '/staff-server' });
        } else if (role === 'kitchen') {
          throw redirect({ to: '/staff-kitchen' });
        }
      }
    }

    // Admins and unauthenticated users stay on this route
  },
})
